export default "__VITE_ASSET__98039cb4__"